__turbopack_context__.v({
  "h2": "bpPZwa_h2",
  "h2Custom": "bpPZwa_h2Custom",
  "h2Md": "bpPZwa_h2Md",
  "h2Small": "bpPZwa_h2Small",
  "leftSideTextWrapper": "bpPZwa_leftSideTextWrapper",
  "p": "bpPZwa_p",
  "pLarge": "bpPZwa_pLarge",
  "pSmall": "bpPZwa_pSmall",
});
